var render = function (_h,_vm) {var _c=_vm._c;return _c('label',_vm._g(_vm._b({ref:"data.ref",staticClass:"base-label block text-sm leading-5 text-gray-700 font-semibold",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},'label',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }